import axios from "axios";

// Retrieve base URL from env
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Axios instance 
const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

let logoutFn = null;

export const setLogoutHandler = (fn) => {
  logoutFn = fn;
};

// Request interceptor → add JWT token if exists
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor 
apiClient.interceptors.response.use(
  (response) => {
    if (response.status < 200 || response.status >= 300) {
      throw new Error(
        `API Error: ${response.status} ${response.statusText}`
      );
    }
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      if (logoutFn) logoutFn();
      const err = new Error("Session expired. Please login again.");
      err.response = error.response;
      return Promise.reject(err);
    }
if (error.response) {
  const responseData = error.response.data || {};

  // Prefer the most specific message available
  const specificMessage =
    responseData?.data?.detail ||
    responseData?.data?.message ||
    responseData?.detail ||
    responseData?.message ||
    error.response.statusText;

  const err = new Error(specificMessage);
  err.status = error.response.status;
  err.data = responseData.data || null;        // <-- nested data (has .detail)
  err.responseData = responseData;             // <-- full body just in case
  err.response = error.response;
  return Promise.reject(err);
}
  }
);

// Common API method
export async function callApi(method, endpoint, data = {}, config = {}) {
  try {
    method = method.toUpperCase();
    
    // Check if data is FormData
    const isFormData = data instanceof FormData;

    const requestConfig = {
      ...config,
      headers: {
        ...config.headers,
      },
    };

    if (isFormData) {
      delete requestConfig.headers['Content-Type'];
    }

    switch (method) {
      case "GET":
        return await apiClient.get(endpoint, { 
          params: data, 
          ...requestConfig 
        });

      case "POST":
        return await apiClient.post(endpoint, data, requestConfig);

      case "PUT":
        return await apiClient.put(endpoint, data, requestConfig);

      case "DELETE":
        return await apiClient.delete(endpoint, { 
          ...requestConfig,
          ...(data && { data }) // For DELETE with body if needed
        });

      default:
        throw new Error(`Unsupported method: ${method}`);
    }
  } catch (error) {
    console.error("API call error:", error);
    throw error;
  }
}





